var _defs, _polygon, _polygon2, _polygon3, _polygon4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_2d",
    "data-name": "2d",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 7.52,
    y1: 59.78,
    x2: 53.83,
    y2: -6.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ff80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#09ff83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#21ff8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#49ff97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#64ffa0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 76.38,
    y1: 131.19,
    x2: 122.69,
    y2: 65.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 43.12,
    y1: 90.78,
    x2: 82.13,
    y2: 35.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 48.01,
    y1: 90.27,
    x2: 88.01,
    y2: 33.14,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "v2D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "35.88 52.06 12.07 28.25 28.25 12.07 52.06 35.88 58.09 29.84 28.25 0 0 28.25 29.84 58.09 35.88 52.06"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "98.16 69.91 92.12 75.94 115.93 99.75 115.93 99.75 99.75 115.93 75.94 92.12 69.91 98.16 99.75 128 128 99.75 98.16 69.91"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "97.17 45.92 33.33 109.75 12.72 115.28 17.56 97.22 10.59 90.25 0.65 127.35 37.75 117.41 103.21 51.95 97.17 45.92"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "109.24 33.85 88.09 12.75 16.65 84.2 22.68 90.23 88.12 24.79 109.24 45.92 127.35 27.81 100.19 0.65 94.13 6.71 115.28 27.81 115.28 27.81 109.24 33.85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2D);
export default __webpack_public_path__ + "static/media/2d.34b108b4ddc00f52c36cddae42217371.svg";
export { ForwardRef as ReactComponent };